import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { PrivacyPolicyService } from 'src/app/core/services/privacy-policy.service';
import { AppButtonComponent } from 'src/app/shared/components/app-button/app-button.component';

@Component({
  selector: 'app-terms-facial',
  standalone: true,
  imports:[CommonModule, AppButtonComponent],
  templateUrl: './terms-facial.component.html',
  styleUrl: './terms-facial.component.scss'
})
export class TermsFacialComponent implements OnInit {

  privacyPolicy: string='';

    backOptions = {
      buttonText: 'Voltar',
      buttonSize: 'btn btn-md px-3 btn-secondary',
      borderRadius: '25px'
    };

    constructor(
      private privacyPolicyService: PrivacyPolicyService
    ) { }

    ngOnInit(): void {
      this.getPrivacyPolicy();
    }

    getPrivacyPolicy() {
      this.privacyPolicyService.getPrivacyPolicy().subscribe((response: any) => {
        this.privacyPolicy = response.content[0].facialText
      });
    }

    back() {
      window.history.back();
    }

}
